import styled from 'styled-components';

export const Content = styled.div`
	transition: 0.3s;
	opacity: 0;
`;
